import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import fr from './locales/fr.json'

const resources = {
  en: { translation: en },
  fr: { translation: fr },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: undefined,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  })

// Keep `<html lang>` in sync with the resolved language. Screen readers and
// search engines key off this attribute; without the sync it would forever
// be the static `lang="en"` from index.html even after a user picks French.
const applyHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng
  }
}
applyHtmlLang(i18n.resolvedLanguage || i18n.language || 'en')
i18n.on('languageChanged', applyHtmlLang)

export default i18n
